



























































































import PromocodeCampaign from '@/datatypes/promocode-campaign';
import PromocodeCampaignService from '@/services/promocode-campaign/PromocodeCampaignService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import User from '@/datatypes/user';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    promocodeCampaign: new PromocodeCampaign({}),
    promocodeCampaignService: new PromocodeCampaignService(),
    hasNext: true,
    errorMessage: '',
    userObject: new User({}),
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      this.getPromocodeCampaign();
    },

    downloadCsv() {
      this.promocodeCampaignService.downloadCsv(this.promocodeCampaign.id).then((response) => {
        const blob = new Blob([response.data], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = response
          .headers['content-disposition']
          .split('filename=')[1]
          .replaceAll('"', '');
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },

    downloadUrlCsv() {
      this.promocodeCampaignService.downloadUrlCsv(this.promocodeCampaign.id).then((response) => {
        const blob = new Blob([response.data], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = response
          .headers['content-disposition']
          .split('filename=')[1]
          .replaceAll('"', '');
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },

    goToClientsThatRedeemed() {
      this.$router.push(`/promotions/${this.$route.params.id}/redeemed`);
    },

    getPromocodeCampaign() {
      const promocodeCampaignId = this.$route.params.id;

      this.promocodeCampaignService.retrieve(promocodeCampaignId).then((response) => {
        this.promocodeCampaign = new PromocodeCampaign(camelcaseKeysDeep(response.data));
      });
    },
  },
});
